import React from "react";
var __jsx = React.createElement;
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** A single icon toolbar button. */
export function ToolbarButton(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    testId = _ref.testId,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    "aria-label": label,
    title: label,
    "data-testid": testId,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    },
    onClick: onClick,
    className: "flex h-7 w-6 flex-shrink-0 items-center justify-center rounded-sds-200 text-sds-base-secondary transition-colors hover:bg-sds-base-secondary hover:text-sds-base-default"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    className: "h-3.5 w-3.5"
  }));
}

/** A thin vertical separator between toolbar groups. */
export function ToolbarDivider() {
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: "mx-0.5 h-5 w-px flex-shrink-0 bg-sds-base-default"
  });
}